module.exports = __webpack_public_path__ + "img/CRIT_AIR_5.ffa2f63e.png";